import type { IconSvgProps } from "@modules/ui/components/huButtonIcon"

export const CalendarIcon: React.FC<IconSvgProps> = (props) => (
  <svg width="51" height="50" viewBox="0 0 51 50" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect
      x="6.83313"
      y="8.88672"
      width="37.4863"
      height="37.4883"
      rx="4.5"
      fill="#1C1C1C"
      stroke="url(#paint0_linear_12933_139415)"
      strokeWidth="3"
    />
    <circle cx="13.9972" cy="14.8867" r="2" fill="#959693" />
    <circle cx="21.7238" cy="14.8867" r="2" fill="#959693" />
    <circle cx="29.4503" cy="14.8867" r="2" fill="#959693" />
    <circle cx="37.1749" cy="14.8867" r="2" fill="#959693" />
    <path
      d="M36.1749 6.125C36.1749 5.57272 36.6226 5.125 37.1749 5.125C37.7272 5.125 38.1749 5.57272 38.1749 6.125V14.8867H36.1749V6.125Z"
      fill="#959693"
    />
    <path
      d="M28.4503 6.125C28.4503 5.57272 28.898 5.125 29.4503 5.125C30.0026 5.125 30.4503 5.57272 30.4503 6.125V14.8867H28.4503V6.125Z"
      fill="#959693"
    />
    <path
      d="M20.7238 6.125C20.7238 5.57272 21.1715 5.125 21.7238 5.125C22.276 5.125 22.7238 5.57272 22.7238 6.125V14.8867H20.7238V6.125Z"
      fill="#959693"
    />
    <path
      d="M12.9972 6.125C12.9972 5.57272 13.4449 5.125 13.9972 5.125C14.5495 5.125 14.9972 5.57272 14.9972 6.125V14.8867H12.9972V6.125Z"
      fill="#959693"
    />
    <rect x="10.2374" y="18.6016" width="5" height="5" rx="1" fill="#282828" />
    <rect x="10.2374" y="24.793" width="5" height="5" rx="1" fill="#282828" />
    <rect x="10.2374" y="30.9844" width="5" height="5" rx="1" fill="#282828" />
    <rect x="10.2374" y="37.1758" width="5" height="5" rx="1" fill="#282828" />
    <rect x="16.6573" y="18.6016" width="5" height="5" rx="1" fill="#282828" />
    <rect x="16.6573" y="24.793" width="5" height="5" rx="1" fill="#6450F7" />
    <rect x="16.6573" y="30.9844" width="5" height="5" rx="1" fill="#282828" />
    <rect x="16.6573" y="37.1758" width="5" height="5" rx="1" fill="#282828" />
    <rect x="23.0773" y="18.6016" width="5" height="5" rx="1" fill="#282828" />
    <rect x="23.0773" y="24.793" width="5" height="5" rx="1" fill="#282828" />
    <rect x="23.0773" y="30.9844" width="5" height="5" rx="1" fill="#6450F7" />
    <rect x="23.0773" y="37.1758" width="5" height="5" rx="1" fill="#282828" />
    <rect x="29.4972" y="18.6016" width="5" height="5" rx="1" fill="#282828" />
    <rect x="29.4972" y="24.793" width="5" height="5" rx="1" fill="#282828" />
    <rect x="29.4972" y="30.9844" width="5" height="5" rx="1" fill="#282828" />
    <rect x="35.9152" y="18.6016" width="5" height="5" rx="1" fill="#282828" />
    <rect x="35.9152" y="24.793" width="5" height="5" rx="1" fill="#282828" />
    <rect x="35.9152" y="30.9844" width="5" height="5" rx="1" fill="#282828" />
    <defs>
      <linearGradient
        id="paint0_linear_12933_139415"
        x1="25.5763"
        y1="10.3867"
        x2="25.5763"
        y2="44.875"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#959693" />
        <stop offset="1" stopColor="#959693" stopOpacity="0.17" />
      </linearGradient>
    </defs>
  </svg>
)
